import { createFileRoute } from "@tanstack/react-router"
import CoreHomePage from "@/components/coreHome/CoreHomePage"

export const Route = createFileRoute("/core/")({ component: CoreHomePage })
